/**
 * 全部资源
 * created by yxy
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../../../base/BaseComponent";
import {Switch,Input, Select, DatePicker} from "antd";

import Delete from '../../../components/Delete'
import Rename from "../../../components/Rename";
import PersonalLibrary from '../../../components/PersonalLibrary'
import {formatTime} from "../../../../../utils";
import StorageSpace from '../../../components/StorageSpace'
import Position from "../../../components/Position";
import PageTableComponent from "../../../components/pageTable/PageTable";
import {HEADER_HEIGHT} from "../../../../../constants";
import $ from "jquery";
const { Search } = Input;
const {RangePicker} = DatePicker;
const { Option } = Select;

export default class SchoolResource extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {

        super(props);
        this.state = {
            data:[],
            searchText:'',
            startTime:'',
            endTime:'',
            page:1,
            size:10,
            selectedRowKeys:[],
            selectedRows:[],//选中的数据
            currentId:'',//当前id
            sortField: 'createTime',//排序字段
            order: -1,//正序|倒序  1|-1
            manageOperationFlag:''
        }
    }

    componentWillMount() {

    }

    componentDidMount() {
        this.setState({startTime:'',endTime:'',searchText:''})
        this.getTable()
    }


    render() {
        return (
            <div style={{background: '#ffffff',
                padding: '24px 32px 16px 32px',
                margin: "15px 0 15px 15px",
                position: 'relative',
                borderRadius:5}}>
                {/*渲染上面的button*/}
                {this.renderBtn()}
                {/*渲染数据*/}
                {this.renderData()}
            </div>
        )
    }
    renderBtn(){
        let newSecondSelectColor =this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")
        return(
            <div style={{display:'flex',}}>
                <div style={{display:'flex',width:'30%'}}>
                    {this.props.type ===1? <PersonalLibrary currrent={this.state.currentId} callBack={()=>{
                        this.goToFirstPage()
                    }
                    }></PersonalLibrary>:<StorageSpace marginLeft={'0'} checkArray={this.state.selectedRows} callBack={()=>{
                        this.goToFirstPage()
                    }}></StorageSpace>}

                </div>
                <div className={'inputName'} style={{width:'70%',display: 'flex', justifyContent: 'flex-end'}}>
                    {this.props.type ===1?
                        <Select defaultValue="全部" style={{ width: '224px',marginRight:20}}   onChange={(value) => this.handleChange(value)}>
                            <Option value= "">全部</Option>
                            <Option value= 'true'>个人文件夹</Option>
                            <Option value= "false">普通文件夹</Option>
                        </Select>:null
                    }
                    <RangePicker allowClear onChange={this.rangePickerChange}/>
                    <Search
                        allowClear={true}
                        placeholder="请输入关键字"
                        onSearch={value => {
                            this.setState({searchText: value,page:1}, () => {
                              this.getList()
                            })
                        }}
                        style={{width: 224,marginLeft:5}}

                    />
                </div>
                <style>
                    {
                        `.inputName .ant-input:focus, .ant-input:hover {border-color:${newSecondSelectColor} !important;}`
                    }
                </style>
            </div>
        )
    }
    handleChange=(value)=>{
       this.setState({manageOperationFlag:value,page:1},()=>{
           this.getList()
       })
    };

    goToFirstPage(){
        this.setState({page:1},()=>{
            this.getList()
        })
    }
    //顶部创建完的去第一个
    renderPosition(){
        return(
            <Position onRef={(position) => this.setPosition = position}
                      virtualFileId={this.state.currentId}
                      id={this.state.currentId}
                      onSaveCallback={(id) => {

                      }}
            ></Position>
        )

    }
    renderData(){
        let newSecondSelectColor =this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")
        let  columns = [
            {
                title: "名称",
                dataIndex: "name",
                ellipsis: true,
                width:this.props.type===1?580:300,
                render: (text, record) =>{
                    let title=text;
                    return (<div style={{display:'flex'}}>
                        <div>
                            <img src={record.icon} style={{width:'24px',height:'24px',objectFit: "contain"}}/>
                        </div>
                        <div>
                            <div
                                title={title}
                                style={{ color: "rgba(0, 0, 0, 0.85)",
                                    width:this.props.type===1?500:250,overflow:'hidden',whiteSpace:'nowrap',
                                    textOverflow:'ellipsis',
                                    fontSize: "16px",
                                    marginLeft:'8px'}}>{text}</div>
                        </div>
                    </div>)
                }}
               ,{
                title: "最近修改时间",
                dataIndex: "updateTime",
                width:150,
                render:(updateTime)=><div  >{formatTime(updateTime)}</div>
            },{
                title: "创建时间",
                dataIndex: "createTime",
                width:150,
                render:(createTime)=><div >{formatTime(createTime)}</div>
            },{
                title: "已储存",
                dataIndex: "Stored",
                width:120,
                render: (text, record) => {
                    let value = record.extendedAttributeJson&&record.extendedAttributeJson.occupationSize?record.extendedAttributeJson.occupationSize:0;
                    let num =  record.extendedAttributeJson&&record.extendedAttributeJson.warningSize?record.extendedAttributeJson.warningSize:0;
                    let color='rgba(0, 0, 0, 0.65)';
                    if(num<1){
                        color = '#F56C6C'

                    }
                    if(num >=1 && num <= 10){
                        color = '#FFBA00'
                    }
                    return (<div style={{color:this.props.type ===1?'rgba(0, 0, 0, 0.65)':color}}>{this.changeSize(value)}</div>)
                }
            }];
        if(this.props.type ===2){

            columns.push(

                {
                title: "储存空间上限",
                dataIndex: "Online",
                ellipsis: true,
                width:120,
                render: (text, record) => {
                    let value = record.extendedAttributeJson&&record.extendedAttributeJson.availableSize?record.extendedAttributeJson.availableSize:0;
                    let num =  record.extendedAttributeJson&&record.extendedAttributeJson.warningSize?record.extendedAttributeJson.warningSize:0;
                    let color='rgba(0, 0, 0, 0.65)';
                    if(num<1){
                        color = '#F56C6C'
                    }
                    if(num >=1 && num <= 10){
                        color = '#FFBA00'
                    }
                    return (<div style={{color:this.props.type ===1?'rgba(0, 0, 0, 0.65)':color}}>{value +'GB'}</div>)
                }
            },{
                    title: "资源下载需申请",
                    dataIndex: "extendedAttributeJson.publicManagement",
                    ellipsis: true,
                    width: 150,
                    render: (text, record) => {
                        return <div><Switch checked={text?text:false} onChange={(e) => this.switchOnChange(e, record)}/></div>
                    }
                })
        }
        columns.push({
            title: "操作",
            dataIndex: "id",
            width:this.props.type===1?180:250,
            render:(id, record)=>{
                let array = []
                array.push(record)
                return<div style={{display:'flex',color:newSecondSelectColor,}}>
                    <div style={{width:'50px'}}> <Delete text={true}  IsNotGoToRecycle={true}  checkArray={array}   IsDefault={false} callBack={()=>{
                       this.RefreshList()
                    }}>删除</Delete></div>
                  {record&&record.extendedAttributeJson&&record.extendedAttributeJson.manageOperationFlag?null:  <div style={{width:'50px'}}> <Rename text={true} checkArray={array} IsDefault={false} callBack={()=>{
                        this.getList()
                    }}></Rename></div>}
                   {this.props.type ===2? <div  style={{width:'150px'}}> <StorageSpace text={true} checkArray={array}  callBack={()=>{
                       this.getList()
                   }}></StorageSpace></div>:null}


                </div>
            }
        });
        const { selectedRowKeys } = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
                this.state.selectedRowKeys = selectedRowKeys;
                this.state.selectedRows =selectedRows;
                this.setState({},()=>{

                })
            },
        };

        return(
            <PageTableComponent
                columns={columns}
                rowSelection={this.props.type ===1?null:rowSelection}
                data={this.state.data}
                page={this.state.page}
                size={this.state.size}
                count={this.state.count}
                onChangePage={(page, size) => {
                    this.onChangePage(page, size)
                }}
            ></PageTableComponent>
        )
    }

    // 删除后的属性
    RefreshList() {
        if (this.state.data.length === 1) {
            this.onChangePage(this.state.page - 1, this.state.size)
        } else {
            this.onChangePage(this.state.page, this.state.size)
        }
    }


    switchOnChange(e,record){
        this.request({
            url: '/cm-sites-storage-management/publicDept/update',
            method: "post",
            body: {virtualFileId:record.id,
                    publicFlag:e
            },
            callBack: (data) => {
                if(data){
                    this.getList()
                }

            }
        });
    }

    onChangePage(page, size) {
        this.setState({page: page, size: size}, () => {
            this.getList()
        })
    }
    //时间选择器
    rangePickerChange = (moment) => {

        if( moment.length){
            let startTime = moment[0]._d.setHours(0, 0, 0, 0);
            let endTime = moment[1]._d.setHours(23, 59, 59);
            let sTime = new Date(startTime).getTime();
            let eTime = new Date(endTime).getTime();
            this.setState({startTime: sTime, endTime: eTime,page:1}, () => {
              this.getList()
            })
        }else{
            this.setState({startTime: '', endTime: '',page:1}, () => {
                this.getList()
            })
        }
    };


  //  size  转换
    changeSize(value){
        if (value < 1024) {
            return value.toFixed(2) + 'B'
        } else if (value >= 1024 && value < Math.pow(1024, 2)) {
            return parseFloat(value / 1024).toFixed(2) + 'KB'
        } else if(value >= Math.pow(1024, 2) && value < Math.pow(1024, 3)){
            return parseFloat(value / Math.pow(1024, 2)).toFixed(2) + 'MB';
        } else if(value > Math.pow(1024, 3)){
            return parseFloat(value / Math.pow(1024, 3)).toFixed(2) + 'GB';
        } else if(value > Math.pow(1024, 4)){
            return parseFloat(value / Math.pow(1024, 4)).toFixed(2) + 'T';
        }
        return value
    }
  // 获取table
    getTable(){
        this.request({
            url: '/cm-sites-storage-management/zykRootDir/getCurrentUserRootDir',
            method: "get",
            body: {alias:this.props.name},
            callBack: (data) => {
                this.setState({currentId:data.virtualFileId},()=>{
                    this.getList();
                    // this.setPosition.getPosition(this.state.currentId, this.state.currentId,)
                })
            }
        });
    }
    //获取列表
    getList(){
        let parms = {
            fid: this.state.currentId,
            page: this.state.page,
            size: this.state.size,
            filterJson:{
                queryName: this.state.searchText?this.state.searchText:'',
                sortField: this.state.sortField,
                order: parseInt(this.state.order),
            }
        };
        if(this.state.manageOperationFlag!==''){
            parms.filterJson.manageOperationFlag = this.state.manageOperationFlag
        }
        let createTime={};
        if(this.state.startTime){
            createTime.startTime = this.state.startTime;

        }
        if(this.state.endTime){
            createTime.endTime = this.state.endTime
        }
        if(this.state.startTime ){
            parms.filterJson.createTime = createTime
        }
        this.request({
            url: '/cm-sites-storage-management/zykFile/zykManagementPageList',
            method: "post",
            body: parms,
            contentType:'json',
            callBack: (data) => {
                if (data) {
                    this.setState({data:data.data,count:data.count,selectedRowKeys:[],selectedRows:[]},()=>{
                        $('.ant-pagination-options-quick-jumper').find('input').val('')
                    })
                }
            }
        });

    }
}